/*
 * Jira Ticket:
 * Created Date: Mon, 20th Apr 2020, 18:02:15 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import gql from 'graphql-tag';
import axios from 'axios';

const UploadAdvertImageMutation = gql`
  mutation uploadAdvertImage($file: FileUploadInput) {
    data: uploadAdvertImage(file: $file) {
      id
      url
      uploadUrl
      contentType
    }
  }
`;

export default async ({ client, file }) => {
  const uploadRequest = await client.mutate({
    mutation: UploadAdvertImageMutation,
    variables: {
      file: { filename: file.rawFile.name, contentType: file.rawFile.type },
    },
  });
  const responseFile = uploadRequest.data.data;
  await axios.put(responseFile.uploadUrl, file.rawFile, {
    headers: {
      'Content-Type': responseFile.contentType,
    },
  });
  return responseFile;
};
